import { cn } from '@/utils/cn'

export type InputProps = {
  id: string
  name: string
  type?: 'text' | 'email' | 'password'
  value: string
  autoComplete?: string
  placeholder?: string
  disabled?: boolean
  invalid?: boolean
  describedBy?: string
  onChange: (value: string) => void
}

export function Input({
  id,
  name,
  type = 'text',
  value,
  autoComplete,
  placeholder,
  disabled = false,
  invalid = false,
  describedBy,
  onChange,
}: InputProps) {
  return (
    <input
      id={id}
      name={name}
      type={type}
      value={value}
      autoComplete={autoComplete}
      placeholder={placeholder}
      disabled={disabled}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      onChange={(event) => onChange(event.target.value)}
      className={cn(
        'w-full border-2 border-ink bg-surface px-3 py-2.5 text-sm text-ink placeholder:text-muted-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:cursor-not-allowed disabled:opacity-60',
        invalid && 'border-accent',
      )}
    />
  )
}
